import { connect } from 'react-redux';
import {
  getHotelName,
  getHotelInfo,
  getHotelMetapolicies,
} from 'src/routes/Hotel/store/hotel';
import AboutHotel from '../../components/AboutHotel';
import { getAirports } from '../../store/selectors/airports';
import { getImportantEvents } from '../../store/selectors/importantEvents';
import { getSpecialHotelInfo } from '../../store/hotel/selectors';

const mapStateToProps = (state) => ({
  text: getHotelInfo(state),
  specialText: getSpecialHotelInfo(state),
  airports: getAirports(state),
  metapolicies: getHotelMetapolicies(state),
  hotelName: getHotelName(state),
  importantEvents: getImportantEvents(state),
});

export default connect(mapStateToProps)(AboutHotel);
